export const PRODUCTSTATUS_DELETE_RESET = 'PRODUCTSTATUS_DELETE_RESET'
export const PRODUCTSTATUS_DELETE_SET_ERROR = 'PRODUCTSTATUS_DELETE_SET_ERROR'
export const PRODUCTSTATUS_DELETE_SET_DELETED = 'PRODUCTSTATUS_DELETE_SET_DELETED'
export const PRODUCTSTATUS_DELETE_TOGGLE_LOADING = 'PRODUCTSTATUS_DELETE_TOGGLE_LOADING'
